import React from 'react';
import './header-style.scss';
import {ReactComponent as LogoBack} from './images/back.svg';
import {useTranslation} from "react-i18next";
import {useSafeNavigate} from '../../../util/useSafeNavigate';

const HeaderSimpleComponent = (props) => {

    const safeNavigate = useSafeNavigate();
    const {t} = useTranslation();
    const {title} = props;

    return (
        <div className="header">
            <div className="header-parallex">
                <div className="header-top">
                    <div className="header-parallex-header">
                        <div className="header-back" onClick={() => safeNavigate(-1)}>
                            <LogoBack/>
                            <p className="header-back-text">{t('back')}</p>
                        </div>
                    </div>
                </div>
                <p className="header-parallex-title">{title}</p>
            </div>
        </div>
    )
};

export default HeaderSimpleComponent;
